import { atom, selector } from "recoil";
import {recoilPersist} from "recoil-persist";

const {persistAtom} = recoilPersist({
    key: "pagePersist",
    storage:sessionStorage, //sessionStorage사용
})


// 2️⃣ `메뉴 상태` 데이터를 저장하는 atom
export const topMenuTypeState = atom({
    key: "topMenuTypeState",
    default: "home",
    effects_UNSTABLE: [persistAtom]
});